

















































































import { Component, Ref, Watch, Prop } from "vue-property-decorator";
import Vue from "vue";
import ViewpointListInput from "@/components/Lists/ViewpointListInput.vue";
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import { Viewpoint } from "@/api/model/Viewpoint";

const decisionsModule = getModule(Decisions);

@Component({
    components: {ViewpointListInput, CardTitle}
})
export default class ViewpointListInputDialog extends Vue{

    @Prop({default: "mdi-calculator", type: String})
    iconName!: string;

    @Prop({default: "", type: String})
    btnText!: string;

    @Prop({default: "", type: String})
    btnClass!: string;


    @Prop({default: true, type: Boolean})
    icon!: boolean;

    @Prop({default: true, type: Boolean})
    small!: boolean;

    @Ref('child')
    viewpointListinput: any;

    @Prop({default: ()=>([]), type: Array})
    viewpointsFromParent!: Viewpoint[]

    @Prop({default: false, type: Boolean})
    listActivator!: boolean

    private saveAsNew = false;
    private save = false;
    private clear = false;
    private loading = false;
    private show = false;
    private editing = false;

    @Watch('show')
    private watchShow() {
        this.editing = false;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    private cancel(){
        this.clear = true;
        this.show = false;
    }
    private saveViewpoint(){
        this.save = true;
    }

    private saveViewpointAsNew() {
        this.saveAsNew = true;
        this.loading = true;
        this.editing = false;
    }

    private clearViewpoint() {
        this.clear = true;
        this.editing = false;
    }
}
